/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcaption1Inputs */

const en_crosspostingcaption1 = /** @type {(inputs: Crosspostingcaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption`)
};

const de_crosspostingcaption1 = /** @type {(inputs: Crosspostingcaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/**
* | output |
* | --- |
* | "Caption" |
*
* @param {Crosspostingcaption1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcaption1 = /** @type {((inputs?: Crosspostingcaption1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcaption1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcaption1(inputs)
	return de_crosspostingcaption1(inputs)
});
export { crosspostingcaption1 as "crosspostingCaption" }